import { defineStore, acceptHMRUpdate } from 'pinia'
import { useCompleteOnboardingMutation } from 'src/composables/account/mutation/useCompleteOnboardingMutation'
import { useDeleteAccountMutation } from 'src/composables/account/mutation/useDeleteAccountMutation'
import { useLeaveAccountMutation } from 'src/composables/account/mutation/useLeaveAccountMutation'
import { usePatchAccountMutation } from 'src/composables/account/mutation/usePatchAccountMutation'
import { useRenameAccountMutation } from 'src/composables/account/mutation/useRenameAccountMutation'
import { useSetupAccountMutation } from 'src/composables/account/mutation/useSetupAccountMutation'
import { useUpdateAccountMutation } from 'src/composables/account/mutation/useUpdateAccountMutation'
import { buildEmailPreferencesPatch } from 'src/services/helpers/auth.helper'
import { useAccountStore } from 'src/stores/account'

export const useAccountActionsStore = defineStore('account-actions', () => {
  const accountStore = useAccountStore()

  const { completeOnboarding, isCompletingOnboarding, completeOnboardingError } =
    useCompleteOnboardingMutation()
  const { deleteAccount, isDeletingAccount, deleteAccountError } = useDeleteAccountMutation()
  const { leaveAccount, isLeavingAccount, leaveAccountError } = useLeaveAccountMutation()
  const { patchAccount, isPatchingAccount, patchAccountError } = usePatchAccountMutation()
  const { renameAccount, isRenamingAccount, renameAccountError } = useRenameAccountMutation()
  const { setupAccount, isSettingUpAccount, setupAccountError } = useSetupAccountMutation()
  const { updateAccount, isUpdatingAccount, updateAccountError } = useUpdateAccountMutation()

  async function updateEmailPreferences(draft) {
    const saved = accountStore.accountData?.emailPreferences
    const patch = saved ? buildEmailPreferencesPatch({ saved, draft }) : null
    if (!patch) return false
    return updateAccount(patch)
  }

  return {
    completeOnboarding,
    isCompletingOnboarding,
    completeOnboardingError,
    deleteAccount,
    isDeletingAccount,
    deleteAccountError,
    leaveAccount,
    isLeavingAccount,
    leaveAccountError,
    patchAccount,
    isPatchingAccount,
    patchAccountError,
    renameAccount,
    isRenamingAccount,
    renameAccountError,
    setupAccount,
    isSettingUpAccount,
    setupAccountError,
    updateAccount,
    updateEmailPreferences,
    isUpdatingAccount,
    updateAccountError,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAccountActionsStore, import.meta.hot))
}
